import AuthorWrapper from '@/layouts/AuthorWrapper'

const Author = () => import('@/pages/Author')

export default {
	path     : '/author',
	component: AuthorWrapper,
	children : [
		{
			path     : '/',
			name     : 'Author',
			component: Author
		}
	]
}
